import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import { changePage, saveSsapFailure, saveSsapSuccess, setData } from '@actions/ssap/ssapActionCreators';
import { executeCallbacks } from '@utils/miscellaneous/executeCallbacks';
import { preventerTools } from '@utils/tools/preventerTools';
import { processJsonTools } from '@utils/tools/processJsonTools';

export function* saveSsapSaga({ callbacks, ssapData }) {

    const taxHouseholdType = 'object';
    const bloodRelationshipPlace = 'household';

    try {
        const {
            blockerCallback
        } = preventerTools.provideObject(callbacks && callbacks.find(cb => typeof cb === 'object'));

        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const data = yield call([ssapService, ssapService.saveApplication], ssapData);

        if(data) {
            const { currentPage } = data;

            if(blockerCallback) {
                yield call(executeCallbacks, blockerCallback);
            } else {
                yield put(
                    setData(
                        processJsonTools.convertTaxHousehold(
                            processJsonTools.convertBloodRelationships(data, bloodRelationshipPlace),
                            taxHouseholdType
                        )
                    )
                );
                yield put(changePage(currentPage, 'increase'));
                yield call(executeCallbacks, callbacks);
            }
            yield put(saveSsapSuccess());
        } else {
            yield put(saveSsapFailure());
        }
    } catch(e) {
        yield put(saveSsapFailure());
    }
}